import React, { useEffect, useState } from "react";
import "./HotelBookingList.scss";
import { CANCELED, PAST, UPCOMING } from "../../constants/stringConstants";
import { handleGetHotelBookingListApiCall } from "../../utils/ApiCalls";
import { useMain } from "../../contexts/MainContext";
import { getCurrentDate } from "../../shared/sharedFunctions";
import AvailHotelCard from "../../containers/AvailHotelCard";

const HotelBookingList = () => {
  const mainContext = useMain();
  const [filterBtn, setFilterBtn] = useState(UPCOMING);
  const [hotelBookingList, setHotelBookingList] = useState([]);
  const handleFilterClick = (value) => {
    setFilterBtn(value);
  };

  useEffect(() => {
    const dataObj = {
      userId: mainContext?.loginDetails?.userId,
      currentDate: getCurrentDate(),
      filterType: filterBtn,
    };
    const response = handleGetHotelBookingListApiCall(dataObj);
    response.then((res) => {
      console.log(res?.data);
      if (res?.status === 200) {
        setHotelBookingList(res?.data);
      }
    });
  }, [filterBtn]);
  // console.log(getCurrentDate(), new Date().getMonth() + 1);
  const handleRemoveHotelBooking = (index) => {
    let tempList = [...hotelBookingList];
    tempList = tempList
      .slice(0, index)
      .concat(tempList.slice(index + 1, tempList.length));
    setHotelBookingList(tempList);
  };
  return (
    <div className="HotelBookingList">
      <div className="HotelBookingList__container_1">
        <div className="content_wrapper">
          <h2 className="main_title">Hotel Booking List</h2>
          <div>
            <button
              className={`filter_btn upcoming_btn ${
                filterBtn === UPCOMING ? "active" : ""
              }`}
              onClick={() => handleFilterClick(UPCOMING)}
            >
              Upcoming
            </button>
            <button
              className={`filter_btn canceled_btn ${
                filterBtn === CANCELED ? "active" : ""
              }`}
              onClick={() => handleFilterClick(CANCELED)}
            >
              Canceled
            </button>
            <button
              className={`filter_btn past_btn ${
                filterBtn === PAST ? "active" : ""
              }`}
              onClick={() => handleFilterClick(PAST)}
            >
              Past
            </button>
          </div>
        </div>
      </div>
      <div className="HotelBookingList__container_2">
        <div className="content_wrapper">
          {hotelBookingList.map((bookingData, index) => {
            return (
              <AvailHotelCard
                data={bookingData}
                isHotelBookingListPage={true}
                filterBtn={filterBtn}
                handleRemoveHotelBooking={() => handleRemoveHotelBooking(index)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HotelBookingList;
